// VARIABLES INITIALIZED TO MANAGE VARIANT SELECTED
var variant_tank_option = '';
var variant_seat_option = '';
var variant_mudguard_option = '';
var variant_tank_selector = '';
var variant_seat_selector = '';
var new_seat_option = '';
var new_mudguard_option = '';
var variant_mudguard_selector = '';
var variant_image = '';
var variant_generic = 'generic_image';
var input_field = false;
var mainProductImgs;
var swiperThumbs;
var galleryThumbs;
var swiperHeader;
var urlParams;
var timeoutExecuted = true;

$(document).ready(function(){

  urlParams = new URLSearchParams(window.location.search);
  
  setTimeout(() => {
   if(urlParams.has("skipstart")){
       $('.configure-button').click();
      }
  },100);

    // UPDATE QUERY PARAMETERS
    function hasPerformanceParameter() {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.has('model');
    }

    var checkExecuted = false;
    function updateURL(parameterName, parameterValue) {
      var url = new URL(window.location.href);
      if (!checkExecuted && timeoutExecuted) {        
        if (url.search.includes('detailing')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
          }, 100);
        }
        if (url.search.includes('seat')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
          }, 100);
        }
        if (url.search.includes('tank')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
          }, 100);
        }
        if (url.search.includes('storage') && !url.search.includes('suspension')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
            $('input[product-name="pannier"]').prop('checked', true);
          }, 100);
        }
        if (url.search.includes('security') && !url.search.includes('suspension') && !url.search.includes('storage')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
            $('input[product-name="gps"]').prop('checked', true);
          }, 100);
          setTimeout(() => {
            $('.swiper-button-next').click();
          }, 100);
        }
        if (url.search.includes('suspension')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
            if (url.search.includes('suspension=1')) {
              $('input[product-name="suspension"]').prop('checked', true);
            }
          }, 100);
        }
        if (url.search.includes('storage')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
            if ($('.rm1').length) {
              $('.swiper-button-next').click();
            }
            if (url.search.includes('storage=1')) {
              $('input[product-name="pannier"]').prop('checked', true);
            }
          }, 100);
        }
        if (url.search.includes('security')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
            if (url.search.includes('security=1')) {
              $('input[product-name="gps"]').prop('checked', true);
            }
          }, 100);
        }
        //RENDER SUMMARY PAGE
        if (url.search.includes('security') && url.search.includes('suspension') && url.search.includes('storage')) {
          checkExecuted = true;
          setTimeout(() => {
            $('.swiper-button-next').click();
          }, 100);
          setTimeout(() => {
            $('.swiper-button-next').click();
          }, 100);
        }
      }
      url.searchParams.set(parameterName, parameterValue);
      try {
        window.history.replaceState({}, '', url);
      } catch (error) {
        console.error(error);
      }
    }

    var modelValue = $('.data-model').val();
    if (modelValue) {
      updateURL('model', modelValue);
    }

    function updateParameters() {
      var selectedTank = $('.color-wrapper .tank.selected');
      var selectedSeat = $('.seat-sku');
      var selectedMudguard = $('.color-wrapper .mudguard.selected');

      var swiperMainClass = $('.swiperMain').attr('class');
        if (swiperMainClass.includes('active-index-1')) {
          if (selectedTank) {
            var tankSkuValue = selectedTank.data('sku');
            updateURL('tank', tankSkuValue);
          }
        } else if (swiperMainClass.includes('active-index-2')) {
          if (selectedTank) {
            var tankSkuValue = selectedTank.data('sku');
            updateURL('tank', tankSkuValue);
          }
          if (selectedSeat) {
            var seatSkuValue = $(".seat.selected").data('sku');
            updateURL('seat', seatSkuValue);
          }
        } else if (swiperMainClass.includes('active-index-3')) {
          if (selectedTank) {
            var tankSkuValue = selectedTank.data('sku');
            updateURL('tank', tankSkuValue);
          }
          if (selectedSeat) {
            var seatSkuValue = $(".seat.selected").data('sku');
            updateURL('seat', seatSkuValue);
          }
          if (selectedMudguard) {
            var mudguardSkuValue = selectedMudguard.data('sku');
            updateURL('detailing', mudguardSkuValue);
            checkSuspensionURL();
            checkStorageURL();
            checkSecurityURL();
          }
        }
      }
  
    // $('.color-image-wrapper').on('click', function() {
    //   timeoutExecuted = false;
    //   updateParameters();
    // });
  
    function checkStorageURL() {
      var storageInput = $('input.product-to-be-added[product-name="pannier"]')
      if (storageInput.is(':checked')) {
        updateURL('storage', '1');
      } else {
        updateURL('storage', '0');
      }
    }  
    function updateStorageURL() {
      var storageInput = $('input.product-to-be-added[product-name="pannier"]')
      if (storageInput.is(':checked')) {
        updateURL('storage', '0');
      } else {
        updateURL('storage', '1');
      }
    }
  
    function checkSuspensionURL() {
      var suspensionInput = $('input.product-to-be-added[product-name="suspension"]')
      if (suspensionInput.is(':checked')) {
        updateURL('suspension', '1');
      } else {
        updateURL('suspension', '0');
      }
    }  
    function updateSuspensionURL() {
      var suspensionInput = $('input.product-to-be-added[product-name="suspension"]')
      if (suspensionInput.is(':checked')) {
        updateURL('suspension', '0');
      } else {
        updateURL('suspension', '1');
      }
    }
  
    function checkSecurityURL() {
      var securityInput = $('input.product-to-be-added[product-name="gps"]')
      if (securityInput.is(':checked')) {
        updateURL('security', '1');
      } else {
        updateURL('security', '0');
      }
    }  
    function updateSecurityURL() {
      var securityInput = $('input.product-to-be-added[product-name="gps"]')
      if (securityInput.is(':checked')) {
        updateURL('security', '0');
      } else {
        updateURL('security', '1');
      }
    }
    
    $('.extra-product-wrapper').on('click', function() {
      var storageName = 'Sacoche Maeving';
      var suspensionName = 'Suspension K-Tech Razor Lite';
      var securityName = 'Traqueur de Sécurité';
      var productName = $(this).data('product-name');

      if (productName === storageName) {
        updateStorageURL();
      }
      if (productName === suspensionName) {
        updateSuspensionURL();
      }
      if (productName === securityName) {
        updateSecurityURL();
      }
    });

  updatePrice();
  
  // CONFIGURATION GALLERY THUMBS
   galleryThumbs = new Swiper(".gallery-thumbs", {
      spaceBetween: 5,
      slidesPerView:5,
      freeMode: false,
      centerInsufficientSlides: true,
      slideToClickedSlide: true
    });
  
  // // CONFIGURATION GALLERY THUMBS
  // galleryThumbs = new Swiper(".gallery-thumbs", {
  //   spaceBetween: 5,
  //   slidesPerView: 5,
  //   allowTouchMove: true
  // });
  
  // MAIN PRODUCT SLIDER
  mainProductImgs = new Swiper(".swiper-product-images", {
    spaceBetween: 0,
    slidesPerView: 1,
    freeMode: false,
    autoHeight: false,
    effect:"fade",
    allowTouchMove: true,
    thumbs: {
       swiper: galleryThumbs,
    },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    }
  });

  
  // CONFIGURATION SLIDER
  swiperThumbs = new Swiper(".swiperThumbs", {
    spaceBetween: 0,
    slidesPerView: 1,
    freeMode: false,
    autoHeight: true,
    lazyPreloadPrevNext:1,
    spaceBetween: 20,
    allowTouchMove: true,
    on: {
      slideChangeTransitionEnd: function () {
        setTimeout(function(){
          if ($('.swiperThumbs .swiper-slide-active').find('.seat-products').length > 0) {
            $('.swiperThumbs .swiper-slide-active .select-variant.selected').click()
          } else {
            $('.swiperThumbs .swiper-slide-active .selected').find('.select-variant').click()
          }

          if (window.screen.width > 1001) {
            $('.gallery-thumbs .swiper-slide').on('click',function(){
              var number = $(this).attr('slideThumb');
              mainProductImgs.slideTo(number);
            });
          }
        }, 50)
      }            
    }
  });
 
  // CONFIGURATION HEADER SLIDER
  swiperHeader = new Swiper('.swiperMain', {
    loop: false,
    draggable: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      afterInit: function () {
        initConfigurator();
      },
      slideChangeTransitionEnd: function () {
        updateProgressBar();
        scrollTop();
        getSKU();

        $('.swiperMain').removeClass(function (index, className) {
          return (className.match(/(^|\s)active-index-\S+/g) || []).join(' ');
        });
  
        var activeIndex = this.activeIndex;
          $('.swiperMain').addClass('active-index-' + activeIndex);
        }
      
    }
  });

  swiperHeader.controller.control = swiperThumbs;
  swiperThumbs.controller.control = swiperHeader;

  // CONFIGURATOR START BUTTON
  $('.configure-button').on('click',function(){
    $('.first-step').hide();
    $('#init-configurator').show();
    $('.swiper-slide:nth-child(1)').addClass('visible-slide');
    // CONFIGURATOR INIT
    // initConfigurator();
    if (window.screen.width < 1001) {
      $(".configuration-header-wrapper").appendTo(".sticky-on-mobile");
      $(".progress-bar").appendTo(".sticky-on-mobile");
    }
    swiperThumbs.update();
    swiperHeader.update();
    setTimeout(function(){
      updateProgressBar();
      scrollTop();
    }, 0);

    // Update images when configurator is started
    updateSliderSwiper(mainProductImgs);
  });

  // Update images at page load
  // updateSliderSwiper(mainProductImgs);
  
  // UPDATE VARIANT SELECTED

  variant_tank_selector = $('.color-image-wrapper.selected img[data-type="tank"]').data('color');
  variant_tank_selector = variant_tank_selector.replaceAll(' ', '_').toLowerCase();
  variant_tank_option = 'tank_' + variant_tank_selector;

  $("input.extra-product-variant-to-be-added").val('');

  variant_mudguard_selector =  $('.color-image-wrapper.selected img[data-type="mudguards"]').data('color');
  variant_mudguard_selector = variant_mudguard_selector.replaceAll(' ', '_').toLowerCase();
  variant_mudguard_option = 'mudguards_' + variant_mudguard_selector;

  $('.select-variant').on('click',function(){  
    var optionValue = $(this).data('type');
    var colorSelected = $(this).data('color');
    var extra_price = $(this).parent().data('price');
    $('.swiper-slide:nth-child(1)').removeClass('visible-slide');
    var money_format_amount_no_decimals = "{{amount_no_decimals}}€";
    if (extra_price < 1) {
      extra_price = "Inclus";
    } else {
      extra_price = '+' + Shopify.formatMoney(extra_price, money_format_amount_no_decimals);
    }
    $('.price-or-included[data-type="' + optionValue + '"]').text(extra_price);
    $('.summary-row[type="' + optionValue + '"] .extra-price').text(extra_price);
    $('.summary-row[type="' + optionValue + '"] .option-name').text(colorSelected);
    $('.color-selected .color-wrapper[data-type="' + optionValue + '"]').text(colorSelected);
    if (optionValue == 'tank'){
      variant_tank_selector = colorSelected;
      variant_tank_selector = variant_tank_selector.replaceAll(' ', '_').toLowerCase();
      variant_tank_option = 'tank_' + variant_tank_selector;
      $('[data-type="tank"]').parent().removeClass('selected');
      $(this).parent().addClass('selected');
    } else if (optionValue == 'seat') {
    variant_seat_selector = $(this).data('color');
    variant_seat_selector = variant_seat_selector.replaceAll(' ', '_').toLowerCase();
    variant_seat_option = 'selle_' + variant_seat_selector;

    function updateOption(str) {
      if (str.charAt(str.length - 1) === 'e') {
        return str.slice(0, -1);
      }
      return str;
    }
    new_seat_option = updateOption(variant_seat_option);
    new_seat_option = 'seat_' + new_seat_option;
      
    $('[name="seat"]').removeClass('selected');
    $(this).addClass('selected');

    let variant_selected = variant_seat_selector.split('_')[0];
    let variant_id_selected = $('[data-options="' + variant_selected + '"]').data('variantid');
    let selectedSeatSku = $('.seat.selected').data('sku');
    let new_title = $(this).data('variant-title');
    let new_variant_title = $(this).data('variant-name');
    let new_price = $(this).data('price');

    let productWrapper = $(this).closest('.extra-product-wrapper');
    productWrapper.find('.seat-variant-image').each(function() {
      if ($(this).data('variant-name') === new_variant_title) {
        $(this).addClass('selected');
        } else {
          $(this).removeClass('selected');
        }
      });

    $('.color-wrapper[data-type="seat"]').text(new_title);
    $('.seat-sku').val(selectedSeatSku);
    $('.price-or-included[data-type="seat"]').text(new_price > 0 ? '+' + Shopify.formatMoney(new_price, money_format_amount_no_decimals) : 'Inclus');
    $('.summary-row[type="' + optionValue + '"] .extra-price').text(new_price > 0 ? '+' + Shopify.formatMoney(new_price, money_format_amount_no_decimals) : 'Inclus');
    $('input.product-variant-id').attr('value', variant_id_selected);

    if (new_price > 0) {
        $("input.extra-product-variant-to-be-added").val(variant_id_selected);
        $(".addon-price").prop('checked', true);
        $(".zero-price").prop('checked', false);
        $(`input[summary-product-name="${new_title}"]`).prop('checked', true);
    } else if (new_price == 0) {
        $("input.extra-product-variant-to-be-added").val('');
        $(".addon-price").prop('checked', false);
        $(".zero-price").prop('checked', true);
        $(`input[summary-product-name="${new_title}"]`).prop('checked', false);
    } 
    } else if (optionValue == 'mudguards') {
      variant_mudguard_selector = colorSelected;
      variant_mudguard_selector = variant_mudguard_selector.replaceAll(' ', '_').toLowerCase();
      new_mudguard_option = variant_mudguard_selector.replaceAll('-', '_');
      variant_mudguard_option = 'mudguards_' + variant_mudguard_selector;
      $('[data-type="mudguards"]').parent().removeClass('selected');
      $(this).parent().addClass('selected');
    }

    if (optionValue == 'tank' || optionValue == 'seat' || optionValue == 'mudguards') {
      let variant_selected = variant_tank_selector + '/' + variant_seat_option + '/' + variant_mudguard_selector;
      $('[data-options="' + variant_selected + '"]').click();
      let variant_id_selected = $('[data-options="' + variant_selected + '"]').data('variantid');
      $('input.product-variant-id').attr('value', variant_id_selected);
      $("input.variant-to-be-added").val(variant_id_selected);
    }
    updateSliderSwiper(mainProductImgs);
    mainProductImgs.update();

    // galleryThumbs.update();
    // swiperThumbs.update();
    updatePrice();
    updateSaveData();
    timeoutExecuted = false;
    updateParameters();
  })

  // UPDATE VARIANT SELECTED FROM SUMMARY
  $(document).on('click','.color-image-wrapper-summary',function(){
    var type = $(this).find('img.select-variant-summary').data('type');
    var color = $(this).find('img.select-variant-summary').data('color');
    var price = $(this).find('img.select-variant-summary').data('price');
    $('.summary-row[type="' + type + '"] .option-name').text(color);
    if (type === 'seat') {
      $('.select-variant[data-type="' + type + '"][data-color="' + color + '"][data-price="' + price + '"]').click();
    } else {
      $('.select-variant[data-type="' + type + '"][data-color="' + color + '"]').click();
    }
    updateSaveData();

    if (type == "tank") {
      var selectedTank = $('.color-wrapper .tank.selected');
      var tankSkuValue = selectedTank?.data('sku');
      if (tankSkuValue) {
        updateURL('tank', tankSkuValue);
      }
    }
    if (type == "seat") {
      var seatSkuValue = $(".seat-products .seat.selected").data('sku');
      if (seatSkuValue) {
        updateURL('seat', seatSkuValue);
      }
    }
    if (type == "mudguards") {
      var selectedMudguard = $('.color-wrapper .mudguard.selected');  
      var mudguardSkuValue = selectedMudguard?.data('sku');
      if (mudguardSkuValue) {
        updateURL('detailing', mudguardSkuValue);
      }
    }
  })
  // SELECT A PRODUCT FROM EXTRA PRODUCT CONFIGURATOR
  $('.extra-product-wrapper:not(.seat-products)').on('click',function(){
    if ($(this).find('input').is(':checked')) {
      if ($(this).find('input').attr('type') === 'checkbox') {
        $(this).find('input').prop('checked', false);
        var row_id = $(this).data('summaryRow');
        var extra_price = $(this).data('noPrice');
        $('.summary-row[data-row-id="' + row_id + '"] .add-product').find('input').prop('checked', false);
        $('.summary-row[data-row-id="' + row_id + '"] .extra-price').text(extra_price);
      }
    } else {
      $(this).find('input').prop('checked', true);
      var row_id = $(this).data('summaryRow');
      var product_name = $(this).data('productName');
      var extra_price = $(this).data('extraPrice');
      $('.summary-row[data-row-id="' + row_id + '"] .add-product-name').text(product_name);
      $('.summary-row[data-row-id="' + row_id + '"] .add-product').find('input.checkbox-summary').prop('checked', true);
      $('.summary-row[data-row-id="' + row_id + '"] .extra-price').text(extra_price);
    }
    updateSaveData();
    updatePrice();
  })
  //TOGGLE ADD-ON SEAT AND EXTRA PRODUCTS
  function updateExtraSeat() {
    const extraSeatSummaryRow = $('input[name="Seat Product"]');
    if (extraSeatSummaryRow.length) {
      const extraSeatInputField = $('#couleur-de-la-selle-1');
      if (extraSeatInputField.is(':checked')) {
        extraSeatSummaryRow.val('Hand-stitched');
      } else {
        extraSeatSummaryRow.val('Embossed');
      }
    }
  }
  updateExtraSeat();  
  
  //TOGGLE SEAT VARIANTS ON THE SUMMARY PAGE
  function updateHandStitched() {
    const extraSeatSummaryRow = $('input[name="Seat Product"]');
    const extraSeatEmbossed = $('#seat-product-1');
    const extraSeatStitched = $('#couleur-de-la-selle-2');
    
    if (extraSeatStitched.is(':checked')) {
      extraSeatSummaryRow.val('Hand-stitched');
      extraSeatEmbossed.prop('checked', false);
      const color = $('.seat.selected').data('color');
      const variant = $('div[data-variant-title="Selle Cousue à la Main"][data-color="' + color + '"]').first();
      variant.click();
      input_field = true;
    } else {
      const color = $('.seat.selected').data('color');
      const variant = $('div[data-variant-title="Selle Embossée"][data-color="' + color + '"]').first();
      variant.click();
      input_field = false;
    }

    if (input_field) {
      $('.color-image-wrapper-summary.zero-price').hide();
      $('.color-image-wrapper-summary.addon-price').css('display', 'flex');
    } else {
      $('.color-image-wrapper-summary.zero-price').css('display', 'flex');
      $('.color-image-wrapper-summary.addon-price').hide();
    }

    // Update URL
    var seatSkuValue = $(".seat-products .seat.selected").data('sku');
    if (seatSkuValue) {
      updateURL('seat', seatSkuValue);
    }    
  }

  
  $('.summary-row[data-row-id="Selle Cousue à la Main"]').on('click', '.add-product', function() {
    updateHandStitched();
  });

  //TOGGLE SEAT VARIANTS ON THE SEAT PAGE
  const seatProducts = $('.seat-products');
  seatProducts.on('click', function(event) {
    event.stopPropagation();
    event.preventDefault();
        
    const $selectedInput = $(this).find('input');
    if (!$selectedInput.is(':checked')) {
      $selectedInput.prop('checked', true);
      const productName = $selectedInput.data('product-name');
      const variant = $(`div[data-variant-title="${productName}"]`).first(); 
      variant.click();
      $(`input[summary-product-name="${productName}"]`).prop('checked', true);
      seatProducts.each(function() {
        if (this !== $selectedInput.closest('.seat-products')[0]) {
          $(this).find('input').prop('checked', false);
          var row_id = $(this).data('summaryRow');
          var extra_price = $(this).data('noPrice');
          $('.summary-row[data-row-id="' + row_id + '"] .add-product').find('input').prop('checked', false);
          $('.summary-row[data-row-id="' + row_id + '"] .extra-price').text(extra_price);
        }
      });
    } else {
      $(this).find('input').prop('checked', true);
      const productName = $(this).data('product-name');
      var row_id = $(this).data('summaryRow');
        seatProducts.each(function() {
        if (this !== $selectedInput.closest('.seat-products')[0]) {
          $(this).find('input').prop('checked', false);
          var row_id = $(this).data('summaryRow');
          var extra_price = $(this).data('noPrice');
          $('.summary-row[data-row-id="' + row_id + '"] .add-product').find('input').prop('checked', false);
          $('.summary-row[data-row-id="' + row_id + '"] .extra-price').text(extra_price);
        }
      });
      var extra_price = $(this).data('extraPrice');
      $('.summary-row[data-row-id="' + row_id + '"] .add-product-name').text(productName);
      $('.summary-row[data-row-id="' + row_id + '"] .extra-price').text(extra_price);
      if ($(this).find('input').attr('type') === 'checkbox') {
        $('.summary-row[data-row-id="' + row_id + '"] .add-product').find('input').prop('checked', true);
      }
    }

    if (parseFloat($(this).data('extra-price')) > 0) {
      $('.color-image-wrapper-summary.zero-price').hide();
      $('.color-image-wrapper-summary.addon-price').css('display', 'flex');
    } else {
      $('.color-image-wrapper-summary.zero-price').css('display', 'flex');
      $('.color-image-wrapper-summary.addon-price').hide();
    }

    updateExtraSeat();
    updateSaveData();
    updatePrice();
    getSKU();
  });

  var sku = $('input.product-to-be-added:checked').data('sku');
  
  // SELECT A PRODUCT FROM EXTRA PRODUCT SUMMARY
  $('.add-product').on('click',function(){
    var row_id = $(this).parent('.summary-row').data('rowId');
    if ($(this).find('input').is(':checked')) {
      var price = $(this).find('input').data('zeroPrice');
      $(this).find('input').prop('checked', false);
      $('.extra-product-wrapper[data-summary-row="' + row_id + '"]').find('input').prop('checked', false);
    } else {
      $(this).find('input').prop('checked', true);
      var price = $(this).find('input').data('price');
      $('.extra-product-wrapper[data-summary-row="' + row_id + '"]').find('input').prop('checked', true);
    }
    $(this).next().text('');
    $(this).next().text(price);
    updateSaveData();
    updatePrice();

    // Update Storage product
    var storageInput = $('input.product-to-be-added[product-name="pannier"]')
    if (storageInput?.is(':checked')) {
      updateURL('storage', '1');
    } else {
      updateURL('storage', '0');
    }

    // Update Suspension product
    var suspensionInput = $('input.product-to-be-added[product-name="suspension"]')
    if (suspensionInput?.is(':checked')) {
      updateURL('suspension', '1');
    } else {
      updateURL('suspension', '0');
    }

    // Update GPS product
    var securityInput = $('input.product-to-be-added[product-name="gps"]')
    if (securityInput?.is(':checked')) {
      updateURL('security', '1');
    } else {
      updateURL('security', '0');
    }
  });

  // NEXT SLIDE
  $('.next-button').on('click',function(){
    let seat_variant = $('.seat.selected')
    seat_variant.click();
    $('.swiperMain .swiper-button-next').click();
    $('.swiper-slide:nth-child(1)').removeClass('visible-slide');
    scrollTop();
  })
  // $('.swiper-button-next').on('click',function(){
  //   let seat_variant = $('.seat.selected')
  //   seat_variant.click();
  //   scrollTop();
  // })
  $('.skip-button').on('click',function(){
    $('.swiperMain .swiper-button-next').click();
    scrollTop();
  })
  $('.save-button').on('click',function(){
    $('.hs_submit.hs-submit input[type="submit"]').click();
  })

  // OPEN MODALS
  $('.modal-trigger').on('click',function(){
    let modalId = $(this).attr('id');
    $('body').addClass('non-scrollable');
    $('#modal-wrapper-' + modalId).addClass('is-open');
    setTimeout(() => {
      $('.modal-wrapper.is-open').fadeIn();
      $('#modal-wrapper-' + modalId + ' .modal-content-wrapper').css('transform','translate(0,0)');
    }, 0);
  })

  // CLOSE MODALS FROM CROSS
  $('.close-icon').on('click',function(){
    closeModal();
  })

  // CLOSE MODALS CLICKING OUTSIDE
  $(document).on('click',function(e){
    if ($(".modal-wrapper.is-open .modal-content-wrapper").is(":visible")) {
      if (!$(e.target).closest(".modal-wrapper.is-open .modal-content-wrapper,.modal-trigger").length) {
        closeModal();
      }
    }
  });
  // LOAD SUMMARY MODAL
  $(document).on('click','.change-option-summary',function(e){
    var modal_content = $(this).find('.color-modal-content').html();
    var position = $(this).parent('.summary-row').offset();
    var overlay_background = '<div class="overlay-grey-background"></div>';
    if (window.screen.width > 750) {
      var modal_element = '<div class="modal-selector" style="display: none"></div>';
    } else {
      var modal_element = '<div class="modal-selector" style="transform: translate(0,100%)"></div>';
    }
    $('body').append(modal_element);
    $('body').append(overlay_background);
    $('.modal-selector').html(modal_content);
    if (window.screen.width > 750) {
      $('.modal-selector').css({'width': $('.change-option-summary').parent('.summary-row').width() + 10,'top': position.top, 'left': position.left});
    } else {
      $('.modal-selector').css({'width': '100%','bottom': '0', 'left': '0','position': 'fixed'});
    }
    $('.overlay-grey-background').show()
    setTimeout(() => {
      $('.modal-selector').addClass('is-block');
      if (window.screen.width > 750) {
        $('.modal-selector.is-block').fadeIn();
      } else {
        $('.modal-selector.is-block').css('transform','translate(0,0)');
      }
    }, 0);
  })

  // CLOSE MODALS CLICKING OUTSIDE
  $(document).on('click',function(e){
    if ($(".modal-selector").is(":visible")) {
      if (!$(e.target).closest(".modal-selector,.change-option-summary").length) {

      if (window.screen.width > 1000) {
        $('.modal-selector.is-block').fadeOut();
      } else {
        $('.modal-selector.is-block').css('transform','translate(0,100%)');
      }
        setTimeout(() => {
          $("body").find('.overlay-grey-background').hide();
          $('.modal-selector').removeClass('is-block');
          $("body").find('.modal-selector').hide();
          $('.modal-selector').html('');
          $('.modal-selector').remove('');
          $('.overlay-grey-background').remove('');
        }, 400);
      }
    }
  });

  // CREATE DATA TO ADD PRODUCTS TO THE CART
  $('.button-atc').on('click',function(e){
    const now = new Date();
    var cartId = getCartId() + now.getHours() + now.getMinutes() + now.getSeconds();
    var ids = [];

    // Adding extra products
    $("input.product-to-be-added:checked").each(function() {
      let name = $(this).attr('name');
      let product_name = $(this).attr('product-name');
      if (product_name != 'bike' && !$(this).hasClass('zero-price') && !$(this).hasClass('addon-price')) {
        var sellingPlan = $(this).closest('.extra-product-wrapper').find("input.extra-product-selling-plan-to-be-added").val() || "";
        var prod = {};
        prod['id'] = $(this).val();
        prod['quantity'] = 1;
        prod['selling_plan'] = sellingPlan;
        prod['properties'] = { "_cartId": cartId };
        ids.push(prod);
      }
    });
        
    // Adding hand-stitched product
    let extraSeatId = $("input.extra-product-variant-to-be-added").val();
    let extraSeatSellingPlan = $('input.extra-seat-selling-plan-to-be-added').val() || "";
    var extraSeat = {};
    if (extraSeatId) {
      extraSeat['id'] = extraSeatId;
      extraSeat['quantity'] = 1;
      extraSeat['selling_plan'] = extraSeatSellingPlan;
      extraSeat['properties'] = { "_cartId": cartId };
      ids.push(extraSeat);
    }
    
    // Adding motorbike
    let motorbikeVariantId = $("input.variant-to-be-added").val();
    let motorbikeSellingPlanId = $("input.selling-plan-to-be-added").val() || "";
    var motorbikeProd = {};
    motorbikeProd['id'] = motorbikeVariantId;
    motorbikeProd['quantity'] = 1;
    motorbikeProd['selling_plan'] = motorbikeSellingPlanId;

    // Add _SKU property only for the main product
    var properties = { "_cartId": cartId };
    // if (motorbikeProd['id'] === motorbikeVariantId) {
    //   var skuId = getSKU();
    //   properties['_SKU'] = skuId;
    // }
    motorbikeProd['properties'] = properties;

    ids.push(motorbikeProd);

    // Creates the data object
    var formData = {};
    formData['items'] = ids;
    addToCart(formData);
  })

  // READ MORE/READ LESS ACTIONS
  $('.read-more').on('click', function(){
    event.stopPropagation();
    let id = $(this).data('open');
    $('.' + id + '-short').hide();
    $('.' + id + '-long').show();
    swiperThumbs.update();
    swiperHeader.update();
    scrollTop();
  })

  $('.read-less').on('click', function(){
    event.stopPropagation();    
    let id = $(this).data('open');
    $('.' + id + '-short').show();
    $('.' + id + '-long').hide();
    swiperThumbs.update();
    swiperHeader.update();
    scrollTop();
  });
})

function escapeSelector(selector) {
  return selector.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
}

// CONFIGURATOR INIT
function initConfigurator(){

  if (urlParams.size > 1 ) {
    $('.first-step').hide();
    $('#init-configurator').show();
    // $('input[type="radio"]').prop('checked', false);
    $('input[type="checkbox"]').prop('checked', false);
    let incorrectParam = false;
    let money_format_amount_no_decimals = "{{amount_no_decimals}}€";
    urlParams.forEach(function (value, key) {
      if (key === 'tank' || key === 'seat' || key === 'detailing') {
        var new_key = key;
        var new_value = value;
        if (key == 'detailing') {
          new_key = 'mudguards';
          new_value = escapeSelector(value);
        }

        $('.select-variant[data-type="' + new_key + '"]').parent().removeClass('selected');
        if ($('#' + new_key + '-' + new_value).length){
          $('#' + new_key + '-' + new_value).addClass('selected');
          let extra_price = $('#' + new_key + '-' + new_value).data('price');
          if (extra_price < 1) {
            extra_price = "Inclus";
          } else {
            extra_price = '+' + Shopify.formatMoney(extra_price, money_format_amount_no_decimals);
          }
          let colorSelected =  $('#' + new_key + '-' + new_value).find('img').data('color');
          $('.summary-row[type="' + new_key + '"] .extra-price').text(extra_price);
          $('.summary-row[type="' + new_key + '"] .option-name').text(colorSelected);
          $('.color-selected .color-wrapper[data-type="' + new_key + '"]').text(colorSelected);
          $('.price-or-included[data-type="' + new_key + '"]').text(extra_price);

          if(new_key === 'seat') {
            const seat_sku = new_value
            const selected_seat = $(".seat-products .seat[data-sku='" + seat_sku + "']")
            const selected_seat_color = selected_seat.data('color')
            const selected_seat_type = selected_seat.data('variant-name')?.includes("Selle Cousue à la Main") ? "Selle Cousue à la Main" : "Embossed"

            setTimeout(function() {
              if (selected_seat_type == "Selle Cousue à la Main") {
                $(".summary-row[type='seat-product'] .add-product").trigger('click')
                $('.select-variant[data-type="seat"][data-color="' + selected_seat_color + '"][data-price!="0"]').click();
                console.log("hello hand sticked clicked");
              } else {
                $('.select-variant[data-type="seat"][data-color="' + selected_seat_color + '"][data-price="0"]').click();
              }
            }, 150)
          }
        } else {
          incorrectParam = true;
          $('.color-image-wrapper[name="' + new_key + '"]:first').addClass('selected');
        }
      } else {
          if (key != 'view' && key != 'utm_campaign'){
            if (key == 'security' && value == '1') {
              setTimeout(function() {
                $('.summary-row[data-row-id="Traqueur de Sécurité"] .add-product').click()
              }, 150)
            }
          if ($('#' + key + '-' + value).length){
            $('#' + key + '-' + value).prop('checked', true);
            let row_id = $('#' + key + '-' + value).parent().parent().data('summaryRow');
            let product_name = $('#' + key + '-' + value).parent().parent().data('productName');
            let extra_price = $('#' + key + '-' + value).parent().parent().data('extraPrice');
            $('.summary-row[data-row-id="' + row_id + '"] .add-product').find('input').prop('checked', true);
            $('.summary-row[data-row-id="' + row_id + '"] .add-product-name').text(product_name);
            $('.summary-row[data-row-id="' + row_id + '"] .extra-price').text(extra_price);
          } else if (key == 'storage' || key == 'security') {
            // Added this else if block because the IDs on the input fields are different than the URL parameter
            // This is a quick fix because otherwise, I would have to change IDs in the HTML and parameter everything to be aligned
            setTimeout(function() {
              if (key == 'storage' && value == '1') {
                $('input.checkbox-summary[data-product-name="pannier"]').parent().click();
              }
            }, 151);
          } else {
            incorrectParam = true;
            $('input[type="radio"][name="' + key + '"]:first').prop('checked', true);
          }
        }
      }
    });

    updatePrice();

    setTimeout(() => {
      if (window.screen.width < 1000) {
        $(".configuration-header-wrapper").appendTo(".sticky-on-mobile");
        $(".progress-bar").appendTo(".sticky-on-mobile");
      }
      var idx = parseInt($('.configuration-header-wrapper .swiper-wrapper').data('qty'));
      if (!incorrectParam) {
        // Update swiper initial slide index
        swiperThumbs.params.initialSlide = idx;
        swiperHeader.params.initialSlide = idx;
        // Update swiper and progress bar
        swiperThumbs.slideTo(idx, 600);
        swiperHeader.slideTo(idx, 600);
        updateProgressBar();
        swiperThumbs.update();
        swiperHeader.update();
      }
        scrollTop();
    }, 100);
    // updateSliderSwiper(mainProductImgs);
  }
  

  // Force-select GPS (only for pre-orders)
  document.querySelectorAll(`
  :has([class*="rm1s-free-upgrades"]),
  :has([class*="rm1s-free-upgrades"]) [data-row-id="GPS Security Tracker"][data-upgrade="free"] .add-product`).forEach((element) => {
    var input = element.querySelector('input');
    input.checked = true; // initalise checked
  });

  // Set first seat product to be checked
  const seatProducts = $('.seat-products');
  
  seatProducts.each(function() {
    const $input = $(this).find('input');
    if ($(this).data('index') === 'seat-product-1') {
      $input.prop('checked', true);
      let new_title = $(this).data('product-name');
      let new_price = $(this).data('extra-price');
      $('.color-wrapper[data-type="seat"]').text(new_title);
      $('.price-or-included[data-type="seat"]').text(new_price > 0 ? '+' + Shopify.formatMoney(new_price, money_format_amount_no_decimals) : 'Inclus');
    }
  });
}

// https://maeving-germany.myshopify.com/products/maeving-rm1s?view=configurator&storage=pannier&tank=3a&performance=2&mudguards=1a

// SCROLL TO THE TOP AFTER MOVE SLIDES
function scrollTop(){
  if (window.screen.width < 1000) {
    var $announcementBar = $('announcement-bar');
    var $header = $('sticky-header');
    var total = 0;
    if ($header.length) {
      total += $header.height();
    }
    if ($announcementBar.length) {
      total += $announcementBar.height();
    }
      window.scrollTo(0, total);
  }
}
// CLOSE MODALS
function closeModal(){
  $('body').removeClass('non-scrollable');
  $('.modal-wrapper.is-open .modal-content-wrapper').css('transform','translate(100vw,0)');
  setTimeout(() => {
    $('.modal-wrapper.is-open').fadeOut(100);
    $('.modal-wrapper.is-open').removeClass('is-open');
  }, 200);
}

// FUNCTION ADD TO CART
function addToCart(formData) {
  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: formData,
      success: addedToCard,
      error: addedToCardFailed

  });
}

function addedToCard() {
  document.location.href = "/cart";
}

function addedToCardFailed(msg) {
  console.log(msg);
}

// UPDATE SLIDER WHEN VARIANT CHANGE
function updateSlider(){
    let first_image = true;
    $('li.thumbnail-list__item').each(function(){
        let alt_text = $(this).find('img').attr('alt');
        if ((alt_text.includes(variant_tank_option) && alt_text.includes(new_seat_option)  && alt_text.includes(variant_mudguard_option)) || alt_text.includes(variant_generic)) {
            $(this).show();
            if (first_image === true){
                first_image = false;
                $(this).find('button').click();
            }
        } else {
        $(this).hide();
        }
    });
}

function updateSliderSwiper(mainProductImgs){

    let first_image = true;
    let matchingSliders = [];

    $('.rm1s-product-images .swiper-slide').each(function(){
        let alt_text = $(this).find('img').attr('alt');
        if ((alt_text.includes(variant_tank_option) && alt_text.includes(new_seat_option) && alt_text.includes(variant_mudguard_option)) || alt_text.includes(variant_generic)) {
            $(this).show();
            matchingSliders.push(this);
        } else {
            $(this).hide();
        }
    });
  
    $('.rm1-product-images .swiper-slide').each(function(){
        let alt_text = $(this).find('img').attr('alt');
        if ((alt_text.includes(variant_tank_option) && alt_text.includes(new_seat_option) && alt_text.includes(new_mudguard_option)) || alt_text.includes(variant_generic)) {
            $(this).show();
            matchingSliders.push(this);
        } else {
            $(this).hide();
        }
    });

    if (matchingSliders.length > 1) {
      let firstSlider = matchingSliders[0];
        
      variant_image = $(firstSlider).find('img').attr('src');
      if (variant_image.startsWith('//')) {
        variant_image = 'https:' + variant_image;
      }
    } else {
      console.log('No first matching slider found');
    }

 if (window.screen.width > 1001) {
   var slideTo = 0;

  
  $('.gallery-thumbs .swiper-slide').each(function(i,item){
     let first_image = true;
     
     if(slideTo > 4){
       slideTo = 0;
     }
     
     let alt_text = $(this).find('img').attr('alt');
        if ((alt_text.includes(variant_tank_option) && alt_text.includes(new_seat_option)) || alt_text.includes(variant_generic)) {
          $(item).show();
          $(item).attr('slideThumb',slideTo);
          slideTo++;
            if (first_image === true){
                first_image = false;
                let firstSlider = $(this).attr('aria-label');
                // let index = firstSlider.split("/");
                // mainProductImgs.slideTo(parseInt(index[0]), 100);
            }
        } else {
        $(this).hide();
        }
    });
    
 }
    // mainProductImgs.update();
    // galleryThumbs.update();
  
}



// PROGRESS BAR
function updateProgressBar () {
  let activeSlider = $('.swiperMain .swiper-slide.swiper-slide-active').attr('aria-label');
  let numbers = activeSlider.split("/");
  let percent = (parseFloat(numbers[0]) * 100) / parseFloat(numbers[1]);
  $('.progress-fill-bar').css('width', percent + '%');
}

// UPDATE SAVE DATA
function updateSaveData() {
  let battery_type = '';
  let tank_color = '';
  let seat_color = '';
  let mudguards_color = '';
  let suspension = 'Default';
  let storage_product = 'None';
  let security_product = 'None';
  let dynamic_image = variant_image;
  let configurationPath = window.location.href;

  $("input.product-to-be-added:checked").each(function() {
      let type = $(this).attr('name');
      let name = $(this).attr('product-name');
      if (type == 'rangement') {
        if (storage_product != 'None') { 
          storage_product = storage_product + ', ';
        } else {
          storage_product = '';
        }
        storage_product = storage_product + $(this).data('productName');
      } else if (type == 'securite') {
        if (security_product != 'None') { 
          security_product = security_product + ', ';
        } else {
          security_product = '';
        }
        security_product = security_product + $(this).data('productName');
      } else if (type == 'suspension') {
        if (suspension != 'Default') { 
          suspension = suspension + ', ';
        } else {
          suspension = '';
        }
        suspension = suspension + $(this).data('productName');
      } else if (name == 'bike') {
        battery_type = $(this).data('productName');
      }

  });
  $(".color-image-wrapper.selected").each(function() {
      let type = $(this).find('img').data('type');
      let color = $(this).find('img').data('color');
      let seat_type = $(this).data('type');
      let seat_name = $(this).data('variant-name');
      if (type == 'tank') {
        tank_color = color;
      } else if (type == 'mudguards'){
        mudguards_color = color;
      }
      if (seat_type == 'seat'){
        seat_color = seat_name;
      }
  });

  $('#battery_type-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(battery_type).change();
  $('#tank_color-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(tank_color).change();
  $('#seat_color-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(seat_color).change();
  $('#mudguards_color-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(mudguards_color).change();
  $('#suspension-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(suspension).change();
  $('#storage_product-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(storage_product).change();
  $('#security_product-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(security_product).change();
  $('#variant_image-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(dynamic_image).change();
  $('#saved_url-5e7e92e0-0dd7-402b-9075-54587f0b1e43').val(configurationPath).change();
}
// CART ID
function getCartId() {
  let cartId = '';
  $("input.product-to-be-added:checked").each(function() {
    let block = $(this).data('block');
    let cartId_value = $(this).data('sku') + '';
    $('#sku-' + block).val(cartId_value);
  });
  $(".color-image-wrapper.selected").each(function() {
    let block = $(this).data('block');
    let cartId_value = $(this).data('sku') + '';
    $('#sku-' + block).val(cartId_value);
  });
  $('.sku-data').each(function(){
    cartId = cartId + $(this).val();
  })
  return cartId
}
// SKUs
function getSKU() {
  let sku = '';
  let skuModel = '';
  let skuClass = '1';   // unused
  let skuBattery = '';  // unused
  let skuPower = '1';   // unused
  let skuMY = '23';     // unused
  let skuCountry = '';  // unused
  let skuColour = '';
  let skuTelematics = '0';
  let skuMudguards = '';
  let skuSeat = '';
  let skuInfills = '0';
  let skuRSUs = '0';
  let skuSuspension = '0';
  let skuStorage = '0';

  skuModel = $('.sku-data').val();

  $("input.product-to-be-added:checked").each(function() {
    let block = $(this).data('block');
    let sku_value = $(this).data('sku') + '';
    let name = $(this).attr('product-name');
    let value = $(this).attr('value');

    if (name === 'bike') {
      skuBattery = sku_value;
      $('#sku-' + block).val(sku_value);
    } else if (name === 'gps') {
      if (sku_value.length < 3 ){
        skuTelematics = sku_value;
        $('#sku-' + block).val(sku_value);
      } else {
        skuTelematics = '0';
      }
    } else if (name === 'pannier') {
      if (sku_value.length < 3 ){
        skuStorage = sku_value;
        $('#sku-' + block).val(sku_value);
      }
    } else if (name === 'suspension') {
      if (sku_value.length < 3 ){
        skuSuspension = sku_value;
        $('#sku-' + block).val(sku_value);
      } else {
        skuSuspension = '0';
      }
    }
  });

  $(".color-image-wrapper.selected").each(function() {
    let block = $(this).data('block');
    let sku_value = $(this).data('sku') + '';
    let name = $(this).attr('name') + '';

    if (name === 'tank') {
      skuColour = sku_value;
      $('#sku-' + block).val(sku_value);
    } else if (name === 'seat') {
      var newSeat = $(".seat-products .seat.selected").data('sku');
      skuSeat = newSeat;
      $('#sku-' + block).val(sku_value);
    } else if (name === 'mudguards') {
      $('#sku-' + block).val(sku_value);
      if (/~/.test(sku_value)) {
        skuMudguards = sku_value.split("~")[0];
        skuInfills = sku_value.split("~")[1];
      } else {
        skuMudguards = sku_value;
      }
    }
  });

  
  // sku = skuModel + skuClass + skuBattery + skuPower +  skuMY  + skuCountry +  skuColour + skuTelematics + skuMudguards + skuSeat;
  sku = skuModel + skuColour + skuTelematics + skuMudguards + skuSeat + skuInfills + /*skuRSUs*/ + skuSuspension + skuStorage;
  
  $('input[name="SKU"]').val(sku.toUpperCase());

  // console.log("SKU:",{
  //   "skuModel": skuModel,
  //   "skuClass": skuClass,
  //   "skuBattery": skuBattery,
  //   "skuPower": skuPower,
  //   "skuMY": skuMY,
  //   "skuCountry": skuCountry,
  //   "skuColour": skuColour,
  //   "skuTelematics": skuTelematics,
  //   "skuMudguards": skuMudguards,
  //   "skuSeat": skuSeat,
  //   "COMPLETE": sku
  // });

  return sku.toUpperCase();
}
// UPDATE PRICES
function updatePrice() {
  const base_price = parseInt($('#product-main-price').val());

  let extra_price = 0;
  let remove_price = 0;
  let data_price = 0;
  $("input.product-to-be-added:checked").each(function() {
    extra_price += parseInt($(this).data('price'));
    if ($(this).attr('name') === 'storage') {
      remove_price += parseInt($(this).data('price'));
    }
  });
  $(".color-image-wrapper:not(.select-variant).selected").each(function() {
    extra_price += parseInt($(this).data('price'));
  });

  extra_price;

  let capCode = '';
  let finance_price = parseInt((extra_price - remove_price) / 100);
  
  switch (finance_price) {
    case 4995:
      capCode = 'M9RS000SBTD A    IZB'
      break;
    case 5295:
      capCode = 'M9RS000MUTD A    IZB'
      break;
    case 5190:
      capCode = 'M9RS000GPTD A    IZB'
      break;
    case 5490:
      capCode = 'M9RS000GMTD A    IZB'
      break;
    case 5990:
      capCode = 'M9RS000GMTD A    IZB'
      break;
    case 6290:
      capCode = 'M9RD000DBTD A    IZB'
      break;
    case 6185:
      capCode = 'M9RD000MUTD A    IZB'
      break;
    case 6485:
      capCode = 'M9RD000GPTD A    IZB'
      break;
    default:
      capCode = 'M9RS000SBTD A    IZB'
  }

  const tankColour = $('input[name="Tank Colour"]').val();    
  
  switch (tankColour) {
    case 'Réservoir Gilbert':
      capCode = 'M9MS000GTTD A   0H0B'
      break;
    case 'Réservoir Vincent':
      capCode = 'M9MS000VTTD A   0H0B'
      break;
    default:
      capCode = 'M9MS000STTD A   0H0B'
  }

  $('#finance-application').attr('data-price',finance_price);
  $('#finance-application').attr('data-cap-code',capCode);
  var price = Shopify.formatMoney(extra_price, shop_money_format).replace(/\.00/g, "");
  $('.price-wrapper .price-item.price-item--regular').css('opacity',1);
  $('.price-wrapper .price-item.price-item--regular').text(price);

  var dynamicPrice = $('.dynamic-price')
  var dataPrice = extra_price / 100
  dynamicPrice.attr('data-product-price', dataPrice)
  dynamicPrice.text(price)
}

$(document).on('click', '.tank', function() {
  updatePrice();
});
